import { LogPointsAPIAction, ActionType } from './actions'
import { LogPointsAPIState } from './model'
import { EMPTY_LOG_POINT_STATES } from '../../util/LogPointsService'

export const logPointsAPIInitialState = {
  configurations: [],
  logPoints: EMPTY_LOG_POINT_STATES,
  loadingLogPoints: true,
  savingLogPoints: false,
  hasSavedYet: false
}

const reducer = (state: LogPointsAPIState = logPointsAPIInitialState, action: LogPointsAPIAction): LogPointsAPIState => {
  switch (action.type) {
    case ActionType.ResetError:
      return {...state, error: undefined}

    case ActionType.SavingLogPoints:
      return {...state, savingLogPoints: true, hasSavedYet: false, error: undefined}

    case ActionType.SavedLogPoints:
      return {...state, savingLogPoints: false, hasSavedYet: true, error: undefined}

    case ActionType.SavedLogPointsError:
      return {...state, savingLogPoints: false, hasSavedYet: false, error: action.payload}

    case ActionType.FetchLogPoints:
      return {
        ...state,
        configurations: logPointsAPIInitialState.configurations,
        logPoints: logPointsAPIInitialState.logPoints,
        loadingLogPoints: logPointsAPIInitialState.loadingLogPoints
      }

    case ActionType.FetchedLogPoints:
      return {...state, logPoints: action.payload.logPoints, loadingLogPoints: false}

    case ActionType.FetchedPolicyConfiguration:
      return {...state, configurations: action.payload.configurations}

    case ActionType.ChangeAppFullDomain:
      return {...state, applicationFullDomain: action.payload.appFullDomain}

    case ActionType.ChangeRuntimeVerifiable:
      return {...state, isRuntimeVerifiable: action.payload.isRuntimeVerifiable}

    case ActionType.ResetDomainAndRuntime:
      return {...state, applicationFullDomain: undefined, isRuntimeVerifiable: undefined}

    default:
      return state
  }
}

export default reducer
